import createReducer from 'shared/utils/createReducer';
import requestsStatuses from 'modules/common/constants/requestsStatuses';
import { LOGOUT } from 'modules/auth/actions/logout';

import {
  GET_CURRENT_CONSULTATION_MEDIA_FROM_CHAT,
  EDIT_FILE_NAME,
  CONSULTATION_MEDIA_DELETE_FROM_CHAT,
} from 'modules/queues/Schedule/actions/onFileMetaDataUpdates';

import { FETCH_ORGANIZATION_CONFIG } from 'modules/common/actions/fetchOrganizationConfig';
import { UPLOAD_CONSULTATION_MEDIA } from '../actions/uploadConsultationMedia';
import { UPLOAD_CONSULTATION_MEDIA_RETRY, UPLOAD_CONSULTATION_MEDIA_DELETE } from '../actions/retryUploadConsultationMedia';
import { CONSULTATION_MEDIA_DELETE } from '../actions/deleteConsultationMedia';
import { GET_CURRENT_CONSULTATION_MEDIA } from '../actions/getCurrentConsultationMedia';
import { GET_UPLOAD_INSTRUCTIONS } from '../actions/getUploadInstructions';
import mediaStatus from '../constants/mediaStatus';

const defaultState = {
  status: requestsStatuses.pending,
  uploadInstructionsStatus: requestsStatuses.pending,
  files: [],
  fileMetaDataList: [],
  fileMetaDataConfig: [],
  uploadInstructions: '',
};

export default createReducer(defaultState, {
  [GET_CURRENT_CONSULTATION_MEDIA.pending]: (state) => ({
    ...state,
    status: requestsStatuses.pending,
  }),

  [GET_CURRENT_CONSULTATION_MEDIA.success]: (state, { payload: { attachments, appointmentId } }) => ({
    ...state,
    fileMetaDataList: attachments,

    // check if local file was not uploaded ( have no it's own metaDataId )
    // and local files do not have duplicated ID's with remote files
    // also do this check only for current consultation
    files: state.files.filter(_file =>
      !_file.metaDataId
      || (!attachments.some(item => item.metaDataId === _file.metaDataId) && _file.appointmentId === appointmentId),
    ),
    status: requestsStatuses.success,
  }),

  [GET_CURRENT_CONSULTATION_MEDIA.failure]: (state) => ({
    ...state,
    status: requestsStatuses.failure,
  }),

  [FETCH_ORGANIZATION_CONFIG.success]: (state, { payload: { fileMetaDataConfig } }) => ({
    ...state,
    fileMetaDataConfig,
  }),

  [FETCH_ORGANIZATION_CONFIG.failure]: (state) => ({
    ...state,
    fileMetaDataConfig: [],
  }),

  [GET_CURRENT_CONSULTATION_MEDIA_FROM_CHAT]: (state, { payload }) => ({
    ...state,
    files: state.files.filter(_file => _file.metaDataId !== payload.metaDataId),
    fileMetaDataList: [
      payload,
      ...state.fileMetaDataList.filter(_file => _file.metaDataId !== payload.metaDataId),
    ],
  }),

  [UPLOAD_CONSULTATION_MEDIA.pending]: (state, { meta }) => ({
    ...state,
    files: [...state.files, { ...meta, status: mediaStatus.LOADING }],
  }),

  [UPLOAD_CONSULTATION_MEDIA_DELETE.success]: (state, { payload }) => ({
    ...state,
    files: state.files.filter(_file => _file.id !== payload.id),
  }),

  [UPLOAD_CONSULTATION_MEDIA_RETRY.success]: (state, { meta }) => ({
    ...state,
    files: state.files.filter(_file => _file.id !== meta.id),
  }),

  [UPLOAD_CONSULTATION_MEDIA.success]: (state, { payload }) => {
    const files = state.files.map(file => file.id === payload.id
      ? { ...file, metaDataId: payload.metaDataId, status: mediaStatus.CREATED }
      : file);

    return { ...state, files };
  },

  [UPLOAD_CONSULTATION_MEDIA.failure]: (state, { meta }) => {
    const files = state.files.map(file => file.id === meta.id
      ? { ...file, status: mediaStatus.FAILED }
      : file);

    return { ...state, files };
  },

  [CONSULTATION_MEDIA_DELETE_FROM_CHAT]: (state, { meta }) => ({
    ...state,
    fileMetaDataList: state
      .fileMetaDataList
      .filter(_file => _file.metaDataId !== meta.metaDataId),
  }),

  [CONSULTATION_MEDIA_DELETE.success]: (state, { payload: { metaDataId } }) => ({
    ...state,
    fileMetaDataList: state
      .fileMetaDataList
      .filter(file => file.metaDataId !== metaDataId),
  }),

  [EDIT_FILE_NAME]: (state, { payload: { name, comment, metaDataId } }) => {
    const fileMetaDataList = state.fileMetaDataList.map(item => item.metaDataId === metaDataId
      ? { ...item, name, comment }
      : item);

    return {
      ...state,
      fileMetaDataList,
    };
  },

  [GET_UPLOAD_INSTRUCTIONS.pending]: (state) => ({
    ...state,
    uploadInstructionsStatus: requestsStatuses.pending,
  }),
  [GET_UPLOAD_INSTRUCTIONS.failure]: (state) => ({
    ...state,
    uploadInstructionsStatus: requestsStatuses.failure,
  }),
  [GET_UPLOAD_INSTRUCTIONS.success]: (state, { payload }) => ({
    ...state,
    uploadInstructionsStatus: requestsStatuses.success,
    uploadInstructions: payload,
  }),

  [LOGOUT.failure]: () => defaultState,
  [LOGOUT.success]: () => defaultState,
});
